import { render, staticRenderFns } from "./SectionAdd.vue?vue&type=template&id=b1772fba&scoped=true&"
import script from "./SectionAdd.vue?vue&type=script&lang=js&"
export * from "./SectionAdd.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b1772fba",
  null
  
)

export default component.exports